import { Site } from 'src/app/classes/models/site';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Contract } from './contract';

export class ContractSite extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ContractSiteProperties: (
    | {
        property: keyof ContractSite;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ContractSite;
        type: 'alias';
      }
    | {
        property: keyof ContractSite;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ContractId', type: 'column', dataType: 'number' },
    { property: 'SiteId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Site', type: 'association', model: 'Site' },
    { property: 'Contract', type: 'association', model: 'Contract' }
  ];

  static {
    ContractSite.ContractSiteProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ContractSite.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ContractSite.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ContractSite.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ContractSiteObject: Partial<ContractSite>) {
    super();

    ContractSite.ContractSiteProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ContractSiteObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ContractId?: number;
  SiteId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  Contract?: Contract;
  Site?: Site;
}
